/**
 * RetroUI <Input> — vendored VERBATIM from Logging-Studio/RetroUI
 * `components/retroui/Input.tsx`. No import rewrites needed (upstream uses inline
 * template strings, not cn()).
 *
 * Carries the resting hard shadow-md (4px) like buttons/cards; on focus it tightens
 * to shadow-xs and shows a 2px primary (yellow) outline. aria-invalid → destructive.
 */
import React, { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const Input: React.FC<InputProps> = ({
  type = 'text',
  placeholder = 'Enter text',
  className = '',
  ...props
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      className={`px-4 py-2 w-full rounded border-2 shadow-md transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary focus:shadow-xs ${
        props['aria-invalid']
          ? 'border-destructive text-destructive shadow-xs shadow-destructive'
          : ''
      } ${className}`}
      {...props}
    />
  );
};
